import React, {useState, useEffect} from 'react';
import './App.css';
import Editor from 'react-simple-code-editor';
import dedent from 'dedent';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-json5';
import 'prismjs/components/prism-jsonp';
import logo from './logo192.png';

function App() {
  const [state, setState] = useState(localStorage.getItem('budget') || dedent`
  {
    "Incomes":{
      "Salary":0
    },
    "Expenses":{
      "Rent":0
    },
    "Savings":{
      "Regular":0
    }
  }`)
  const [totals, setTotals] = useState({
    "Income": 0,
    "Expenses":0,
    "Savings":0,
    "Total": 0
  })

  useEffect(()=>{
    localStorage.setItem('budget', state);
    if(isValidJson(state)){
      calculateBudget(state)
    }
  }, [state])

  const changeBudget = (code) =>{
    setState(code)
    if(isValidJson(code)){
      calculateBudget(code)
    }
  }
  
  const isValidJson = (json) =>{
    try {
      JSON.parse(json);
    } catch (error) {
      return false;
    }
    return true;
  }

  const exportJson = ()=>{
    const element = document.createElement("a");
    const file = new Blob([state], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = "budget.json";
    document.body.appendChild(element);
    element.click();
  }

  const calculateBudget = (data) =>{
    let budget = JSON.parse(data);
    let incomes = Object.values(budget.Incomes);
    let expenses = Object.values(budget.Expenses);
    let savings = Object.values(budget.Savings);
    let tIncomes = 0;
    let tExpenses = 0;
    let tSavings = 0;
    incomes.map(i=> tIncomes+=i);
    expenses.map(e=> tExpenses+=e);
    savings.map(s=> tSavings+=s);
    setTotals({
      Income: tIncomes,
      Expenses: tExpenses,
      Savings: tSavings,
      Total: tIncomes - (tExpenses+tSavings)
    })
  }
  return (
    <div >
      <nav className="nav">
        <div className="nav-left">
          {/* <a className="active">Link 1</a>
          <a>Link 2</a> */}
        </div>
        <div className="nav-center">
          <a className="brand">
            <img  src={logo} alt="Logo"/>
          </a>
        </div>
        <div className="nav-right">
          <button className="button clear" onClick={()=>exportJson()}>
            Export Json
          </button>
          
        </div>
      </nav>
      <div className="is-full-screen is-center is-vertical-align">
        <div>
        <div className="row is-center">
          <div className="card">
            <table>
              <thead>
                <tr>
                  <th>Incomes</th>
                  <th>Expenses</th>
                  <th>Savings</th>
                  <th>Totals</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{totals.Income}</td>
                  <td>{totals.Expenses}</td>
                  <td>{totals.Savings}</td>
                  <td>{totals.Total}</td>
                </tr>
              </tbody>

            </table>
          </div>
        
        </div>
        <div className="row is-center">
          <div className="">
            <Editor
              value={state}
              onValueChange={code =>changeBudget(code) }
              highlight={code => highlight(code, languages.json)}
              padding={10}
              style={{
                fontFamily: '"Fira code", "Fira Mono", monospace',
                fontSize: 12,
              }}
            />
          </div>
        </div>
        </div>
        
        
        
      </div>
      
      
      
    </div>
  );
}

export default App;
